import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useLanguageCode } from './index';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
export var RedirectToUrlWithLanguageCode = function RedirectToUrlWithLanguageCode() {
  var _useLanguageCode = useLanguageCode(),
      _useLanguageCode2 = _slicedToArray(_useLanguageCode, 1),
      lang = _useLanguageCode2[0];

  var location = useLocation();
  return React.createElement(Navigate, {
    to: Object.assign(Object.assign({}, location), {
      pathname: lang + location.pathname
    }),
    state: location.state
  });
};